import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { MOBILE_MIN_WIDTH_BREAKPOINTS } from "@faire/help-center-utils/consts/MOBILE_MIN_WIDTH_BREAKPOINTS";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { trackCxFoundationsRelatedarticleslearnmoreClick } from "@faire/web-api/events/cxFoundations/click/relatedarticleslearnmore";
import { trackHelpCenterSelfServeArticleLinkClick } from "@faire/web-api/events/helpCenter/click/selfServeArticleLink";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import kebabCase from "lodash/kebabCase";
import React, { useState } from "react";
import styled from "styled-components";
export var ListOfArticles = function ListOfArticles(_ref) {
  var articles = _ref.articles,
    viewHasInstantAnswer = _ref.viewHasInstantAnswer,
    onClickOnArticle = _ref.onClickOnArticle;
  var _useViewport = useViewport(),
    isTabletAndAbove = _useViewport.isTabletAndAbove;
  var maxNumberOfArticles = getMaxNumberOfArticles(isTabletAndAbove, viewHasInstantAnswer);
  var _useState = useState(articles.length <= maxNumberOfArticles),
    _useState2 = _slicedToArray(_useState, 2),
    allArticlesVisible = _useState2[0],
    setAllArticlesVisible = _useState2[1];
  var retailerToken = getRetailerToken();
  var brandToken = getBrandToken();
  var showMoreCtaOnClickHandler = function showMoreCtaOnClickHandler() {
    setAllArticlesVisible(true);
    trackCxFoundationsRelatedarticleslearnmoreClick(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", brandToken !== null && brandToken !== void 0 ? brandToken : "");
  };
  return /*#__PURE__*/React.createElement("ul", null, articles.map(function (article, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: article.id
    }, allArticlesVisible || index < maxNumberOfArticles ? ( /*#__PURE__*/React.createElement(Column, {
      align: "flex-start"
    }, /*#__PURE__*/React.createElement(Spacer, {
      height: index === 0 ? "1/2x" : "2x"
    }), /*#__PURE__*/React.createElement(ArticleItem, {
      article: article,
      onClick: onClickOnArticle
    }))) : null);
  }), /*#__PURE__*/React.createElement(ShowMoreCta, {
    visibleWhen: !allArticlesVisible,
    onClick: showMoreCtaOnClickHandler
  }));
};
var getMaxNumberOfArticles = function getMaxNumberOfArticles(isTabletAndAbove, hasInstantAnswer) {
  var width = getWindowOrThrow().innerWidth;
  if (isTabletAndAbove) {
    return hasInstantAnswer ? 2 : 5;
  }
  if (width <= MOBILE_MIN_WIDTH_BREAKPOINTS.SMALL) {
    return hasInstantAnswer ? 1 : 4;
  }
  return hasInstantAnswer ? 2 : 6;
};
var ArticleItem = function ArticleItem(_ref2) {
  var article = _ref2.article,
    onClick = _ref2.onClick;
  var articleLinkClick = function articleLinkClick() {
    trackHelpCenterSelfServeArticleLinkClick(article.id, article.name);
    onClick(article.id);
  };
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: article.getLink(),
    target: "__blank",
    onClick: articleLinkClick
  }, /*#__PURE__*/React.createElement(Typography, {
    "data-test-id": kebabCase(article.name),
    variant: "paragraphSansRegular"
  }, article.name));
};
var ShowMoreCta = function ShowMoreCta(_ref3) {
  var visibleWhen = _ref3.visibleWhen,
    onClick = _ref3.onClick;
  if (!visibleWhen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(InlineCta, {
    variant: "paragraphSansRegular",
    onClick: onClick,
    "data-test-id": "show-more-help-articles-btn"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fGM4OC",
    defaultMessage: [{
      "type": 0,
      "value": "+ Show more"
    }]
  })));
};
var InlineCta = styled(Typography).withConfig({
  displayName: "ListOfArticles__InlineCta"
})(["text-decoration:underline;cursor:pointer;"]);